import { render, staticRenderFns } from "./RmaShippingAddress.vue?vue&type=template&id=6ba0b1c0&scoped=true&"
import script from "./RmaShippingAddress.vue?vue&type=script&lang=js&"
export * from "./RmaShippingAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba0b1c0",
  null
  
)

export default component.exports